import {get} from "../../../DAL/data-provider";
import {Response} from "../../feadback/interfaces";

const gdpr_static_url = '/api/GDPR/GDPR/'

/**
 * update GDPR in DB per cookie
 */
export const updateGDPR = (isUpdateDB:boolean=false) : Promise<Response> => {
    return get(`${gdpr_static_url}update-gdpr?isUpdateDB=${isUpdateDB}`,null);
}